/**
 * PurchaseOrderValidationSection Component
 *
 * Purchase order validation — the rule validation always runs and has no settings; the
 * section only explains what it checks and what it gates.
 */
import { Badge, Paper } from '@insio/ui-toolkit';
import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';

export function PurchaseOrderValidationSection() {
  const t = useFeatureTranslation('systemSettings.automation.purchaseOrderValidation');

  return (
    <div className='space-y-lg'>
      <div>
        <h2 className='text-xl font-bold text-foreground-base'>{t('title')}</h2>
        <p className='text-sm text-foreground-muted mt-xs'>{t('description')}</p>
      </div>

      <Paper
        heading='stripe'
        bleed
        padding='none'
        testId='purchase-order-validation-standard-section'
      >
        <Paper.Title>
          <h2>{t('standard.title')}</h2>
        </Paper.Title>
        <Paper.Action>
          <Badge color='neutral' size='sm'>
            {t('standard.badge')}
          </Badge>
        </Paper.Action>
        <Paper.Content className='space-y-md'>
          <p className='text-sm text-foreground-muted'>{t('standard.description')}</p>
        </Paper.Content>
      </Paper>
    </div>
  );
}
